<template>
  <div class="d-flex flex-column align-items-end">
    <!-- Pagination Controls -->
    <div class="btn-group mb-2" role="group" aria-label="Pagination">
      <!-- First Page -->
      <button 
        @click="goToFirst"
        class="btn btn-sm btn-outline-secondary"
        :disabled="currentPage === 1"
      >
        <i class="bi bi-chevron-bar-left"></i>
      </button>
      
      <!-- Previous Page -->
      <button 
        @click="goToPrevious"
        class="btn btn-sm btn-outline-secondary"
        :disabled="currentPage === 1"
      >
        <i class="bi bi-chevron-left"></i>
      </button>
      
      <!-- Current Page Indicator -->
      <span class="btn btn-sm border-dark text-dark px-3">
        {{ currentPage }} / {{ totalPages }}
      </span>
      
      <!-- Next Page -->
      <button 
        @click="goToNext"
        class="btn btn-sm btn-outline-secondary"
        :disabled="currentPage === totalPages"
      >
        <i class="bi bi-chevron-right"></i>
      </button>
      
      <!-- Last Page -->
      <button 
        @click="goToLast"
        class="btn btn-sm btn-outline-secondary"
        :disabled="currentPage === totalPages"
      >
        <i class="bi bi-chevron-bar-right"></i>
      </button>
    </div>
    
    <!-- Summary -->
    <div class="text-muted small text-center">
      Showing {{ startItem > 0 ? startItem : 0 }}-{{ endItem }} of {{ totalItems }} items
    </div>
  </div>
</template>

<script setup>
import { computed,defineProps,defineEmits } from 'vue';

const props = defineProps({
  currentPage: {
    type: Number,
    required: true,
    default:  1
  },
  itemsPerPage: {
    type: Number,
    default: 50
  },
  totalItems: {
    type: Number,
    required: true,
    default: 0
  }
});

const emit = defineEmits(['page-changed']);

const totalPages = computed(() => Math.ceil(props.totalItems / props.itemsPerPage));
const startItem = computed(() => (props.currentPage - 1) * props.itemsPerPage + 1);
const endItem = computed(() => Math.min(props.currentPage * props.itemsPerPage, props.totalItems));

function goToFirst() {
  if (props.currentPage !== 1) emit('page-changed', 1);
}

function goToPrevious() {
  if (props.currentPage > 1) emit('page-changed', props.currentPage - 1);
}

function goToNext() {
  if (props.currentPage < totalPages.value) emit('page-changed', props.currentPage + 1);
}

function goToLast() {
  if (props.currentPage !== totalPages.value) emit('page-changed', totalPages.value);
}
</script>

<style scoped>
/* Custom styling for better mobile appearance */
.btn-group {
  flex-wrap: nowrap;
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}

/* Hide scrollbar while keeping functionality */
.btn-group::-webkit-scrollbar {
  display: none;
}

/* Make the current page indicator stand out */
.btn-outline-primary {
  transition: all 0.2s ease;
}

.btn-outline-primary:hover:not(:disabled) {
  background-color: var(--bs-primary);
  color: white !important;
}
</style>